import XLSX from "sheetjs-style-v2";

function exportFromTable({
  filename,
  tableId,
  sheetRemoveFields,
  formatCellFnc,
  isExactly = false,
  selector,
}) {
  let tbl = document.getElementById(tableId);
  if (!tbl) {
    throw new Error("Cannot find view Id");
  }
  if (!isExactly) {
    if (selector) {
      tbl = tbl.querySelector(selector);
    }
  }

  if (!tbl) {
    throw new Error("Cannot find table");
  }

  let wb = XLSX.utils.table_to_book(tbl, { cellDates: true });
  if (sheetRemoveFields) {
    for (let i in wb.Sheets["Sheet1"]) {
      if (sheetRemoveFields.indexOf(wb.Sheets["Sheet1"][i].v) >= 0) {
        delete wb.Sheets["Sheet1"][i];
      }
    }
  }
  // check format cell
  if (
    formatCellFnc &&
    typeof formatCellFnc === "function" &&
    wb?.Sheets?.Sheet1
  ) {
    formatCellFnc(wb.Sheets["Sheet1"]);
  }

  // SET WIDTH FOR COL 1 -> 5 IS 150
  wb.Sheets["Sheet1"]["!cols"] = [
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
  ];
  return XLSX.writeFile(wb, filename + ".xlsx", { cellStyles: true });
}

export default exportFromTable;
